<template>
    <div v-if="visible"
         class="border trans-ease px-20 py-6"
    >
        <div v-if="!interim.contact_mail" class="flex items-center justify-between">
            <div class="flex items-center">
                <div class="w-80 flex items-center justify-center border-r border-primary-20 pr-24 h-42 overflow-hidden">
                    <img :src="interim.logo" class="h-full w-full object-contain">
                </div>
                <p class="font-semibold text-body pl-24">{{ interim.name }}</p>
            </div>

            <p class="text-semantic-error text-body-sm whitespace-nowrap">
                {{ $t('interims.no_contact_mail_set') }}
            </p>
        </div>
        <toggle v-else
                v-model="form.interimIds"
                :value="interim.id"
                big
                classes="items-center justify-end"
        >
            <template #before>
                <div class="flex items-center w-4/5 mr-auto">
                    <div class="w-80 flex items-center justify-center border-r border-primary-20 pr-24 h-42 overflow-hidden">
                        <img :src="interim.logo" class="h-full w-full object-contain">
                    </div>

                    <div class="flex mx-24">
                        <tooltip offset="0,16">
                            <template #default>
                                <svg-icon
                                    v-if="interim.linked || interim.connect_mail"
                                    :class="[interim.linked ? 'text-secondary' : 'text-semantic-warning']"
                                    class="max-w-16 max-h-16"
                                    type="link"
                                />
                                <svg-icon
                                    v-else
                                    class="max-w-16 max-h-16 text-primary-20"
                                    type="link-off"
                                />
                            </template>
                            <template #tooltip>
                                <div class="max-w-240 whitespace-normal">
                                    <p v-if="interim.linked" v-html="$t('interims.connection_status.connected', {interim: interim.name})"></p>
                                    <p v-else-if="interim.connect_mail" v-html="$t('interims.connection_status.pending', {interim: interim.name, mail: interim.connect_mail})"></p>
                                    <p v-else v-html="$t('interims.connection_status.disconnected', {interim: interim.name})"></p>
                                </div>
                            </template>
                        </tooltip>
                    </div>

                    <p class="font-semibold text-body">{{ interim.name }}</p>
                </div>
            </template>
        </toggle>
    </div>
</template>


<script>
import Toggle from './forms/Toggle';
import SvgIcon from './ui/SvgIcon';
import Tooltip from './navigation/Tooltip';

export default {
    components: {Tooltip, SvgIcon, Toggle},
    props: {
        visible: Boolean,
        interim: Object,
        form: Object,
    },
};
</script>
